module.exports = __webpack_public_path__ + "static/media/marker.18dbe49a.svg";